export default "__VITE_ASSET__DmYFZI5T__"